// extracted by mini-css-extract-plugin
export default {"leftContainer":"RegisterCard_leftContainer__Dy0is","rightContainer":"RegisterCard_rightContainer__m8R1b","container":"RegisterCard_container__5Ccul"};